import routes from '../constants/routes';
import discordIcon from '../assets/icons/Discord icon.svg';
import tgIcon from '../assets/icons/telegram-no-circle.svg';
// import i18n from 'i18next';
// import partner from '../assets/icons/logo/rb-partner-ru.svg';

// eslint-disable-next-line import/prefer-default-export
export const menuLinks = [
  {
    name: 'Preflop Range',
    linkTo: routes.app.combinationTable.root,
    external: false,
    onLanding: false,
  },
  {
    name: 'Preflop Train',
    linkTo: routes.app.trainingGame.root,
    external: false,
    onLanding: false,
  },
  {
    name: 'Preflop Results',
    linkTo: routes.app.resultsTable.root,
    external: false,
    onLanding: false,
  },
  {
    name: 'Flop',
    linkTo: routes.app.postflop.root,
    external: false,
    onLanding: false,
  },
  {
    name: 'Flop Results',
    linkTo: routes.app.postflopResults.root,
    external: false,
    onLanding: false,
  },
  {
    name: 'Guides',
    linkTo: routes.app.articles.root,
    external: false,
    onLanding: false,
  },
  // {
  //   name: 'rakeBackPartner',
  //   linkTo: 'https://worldpokerdeals.com/',
  //   linkRu: 'https://ru.worldpokerdeals.com/',
  //   external: true,
  //   icon: partner,
  // },
  {
    name: 'Discord',
    linkTo: 'https://discord.gg/36k9nmFsxT',
    external: true,
    icon: discordIcon,
  },
  {
    name: 'Telegram',
    linkTo: 'https://t.me/omahaprocom',
    external: true,
    icon: tgIcon,
  },
  // { name: 'Terms of use', linkTo: routes.app.root },

];
